import React from 'react';
import ReactDOM from 'react-dom/client';
import G from "./libs/Glob.mjs";
import './media/css/index.css';
import './media/css/MyBootstrap.css';
import App from './components/App.mjs';
import reportWebVitals from './reportWebVitals';
import appBootstrapSetup from "./libs/appBootstrapSetup.mjs";

await appBootstrapSetup();

const start = () => {
	try {
		ReactDOM.createRoot(
			window.document.getElementById(G.prop.appRootNode)
		).render(
			<React.StrictMode>
				<App/>
			</React.StrictMode>
		);
	} catch (error) {
		console.error(error);
		setTimeout(start, 100);
	}
}

setTimeout(start );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
